import { faHandshake } from '@fortawesome/free-solid-svg-icons';

/**
 * Cargo Bid/Offer (OfferGenerator) walkthrough.
 *
 * Walks the create-bid screen end-to-end: header chrome, stepper, the six
 * clause-driven sections, and the two primary outcomes (save as draft or
 * promote to a recap).
 *
 * Cargo-only by design - Bunkers does not use the offer generator. The form
 * defaults to ``commodityType === 'solids'`` when no location.state is
 * passed, which is exactly what we want for an onboarding tour.
 */

const NEW_BID_ROUTE = '/offer-generator?type=new&dealType=Bid';

const cargoBidOfferTour = {
    id: 'cargo-bid-offer',
    title: 'Cargo: New Bid / Offer',
    description:
        'Deep-dive on the bid/offer form - parties, commodity, logistics, quality, pricing, terms - and the path from draft to recap.',
    estimatedMinutes: 4,
    startRoute: NEW_BID_ROUTE,
    icon: faHandshake,
    group: 'flow',
    steps: [
        {
            target: '.offer-generator-wrapper',
            title: 'New Bid - Offer Generator',
            content:
                'This is where every Cargo deal begins. The form is split into six clause groups; each group corresponds to a step in the stepper above the form.',
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.offer-generator-back-button',
            title: 'Back to Trade Ops',
            content:
                'Heading back without saving prompts a confirmation dialog so you do not lose work. The dialog also offers to save the current state as a draft before leaving.',
            placement: 'bottom',
        },
        {
            target: '.hms-stepper-bar',
            title: 'Section stepper',
            content:
                'Six sections: Parties, Commodity, Logistics, Quality, Pricing, Terms & Validity. Click any pill to jump straight to that section - the form below scrolls to the matching anchor.',
            placement: 'bottom',
        },
        {
            target: '#hms-anchor-offer-parties',
            title: 'Parties',
            content:
                'Who is buying and who is selling. Pick existing CRM partners as seller and buyer; if a partner is missing, create it from CRM first. The clause text below auto-populates from the partner profile.',
            placement: 'top',
        },
        {
            target: '#hms-anchor-offer-commodity',
            title: 'Commodity',
            content:
                'Product, quantity and Incoterms. The commodity drop-down is sourced from the Product Module - if you cannot find what you need, add it there first.',
            placement: 'top',
        },
        {
            target: '#hms-anchor-offer-pricing',
            title: 'Pricing',
            content:
                'Base price plus any quality adjustments and price escalators. This is the most-edited section of the form during negotiation.',
            placement: 'top',
        },
        {
            target: '.offer-button.draft-button',
            title: 'Save as draft',
            content:
                'Saving a draft assigns a transaction number and stores the deal so you can come back later. Drafts live under the Bid/Offer tab in Trade Ops Cargo.',
            placement: 'bottom',
        },
        {
            target: '.offer-button.recap-button',
            title: 'Promote to recap',
            content:
                'When both sides have agreed on terms, click here to convert the draft into a Trade Recap - the formal contract record that drives deliveries, financials and invoicing.',
            placement: 'bottom',
        },
        {
            target: '.offer-generator-wrapper',
            title: 'You are good to go',
            content:
                'That is the bid/offer flow. From here a deal becomes a recap, a recap drives a delivery, and the delivery is what gets invoiced. Re-run this tour any time from Hamster Training.',
            placement: 'center',
            disableBeacon: true,
            isLast: true,
        },
    ],
};

export default cargoBidOfferTour;
